var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "649.000000pt",
    height: "529.000000pt",
    viewBox: "0 0 649.000000 529.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,529.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2790 4524 c-8 -9 -31 -25 -50 -38 -42 -26 -75 -88 -60 -114 5 -9 23 -51 41 -92 41 -99 191 -402 302 -615 49 -93 127 -244 174 -335 166 -321 203 -382 285 -461 50 -48 119 -89 152 -89 38 0 66 36 66 86 0 30 -12 65 -44 126 -24 45 -87 169 -141 273 -145 279 -150 289 -284 544 -145 275 -321 636 -321 659 0 16 -69 72 -87 71 -10 0 -25 -7 -33 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 3678 c-27 -5 -57 -10 -65 -12 -43 -7 -156 -73 -203 -119 -70 -69 -112 -145 -137 -248 -19 -82 -20 -114 -20 -1435 0 -1313 1 -1353 20 -1428 26 -104 63 -169 135 -241 73 -73 142 -111 232 -130 101 -22 5264 -22 5364 -1 133 29 267 133 327 256 64 130 62 70 62 1550 0 1318 -1 1347 -20 1430 -43 179 -147 294 -324 359 l-71 26 -537 3 c-296 2 -538 1 -538 -1 0 -2 16 -35 36 -73 60 -113 328 -651 383 -766 l51 -108 320 0 320 0 0 -1112 c0 -870 -3 -1118 -13 -1138 -7 -13 -28 -35 -46 -47 l-34 -23 -2596 2 c-2872 3 -2634 -3 -2675 68 -21 35 -21 46 -24 1143 l-2 1107 1290 0 1290 0 -39 51 c-34 45 -92 151 -291 534 -26 50 -80 152 -119 228 l-73 137 -976 -1 c-572 -1 -998 -5 -1027 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2292 2103 c-11 -39 -9 -283 3 -303 4 -7 308 -10 960 -10 l954 0 -28 48 c-16 26 -57 92 -91 147 -34 55 -70 112 -79 127 l-16 28 -846 0 -846 0 -11 -37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294 1357 c-6 -8 -10 -69 -10 -162 0 -135 2 -152 20 -167 18 -17 91 -18 1238 -18 670 0 1218 3 1218 6 0 3 -33 46 -73 97 -88 112 -149 193 -172 230 l-17 27 -1097 0 c-855 -1 -1098 -3 -1107 -13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDda);
export default __webpack_public_path__ + "static/media/dda.307070648f32ef03938965732ae2c4f8.svg";
export { ForwardRef as ReactComponent };